import { Card } from "react-bootstrap";
import styled from "styled-components";

export const CardContainer = styled(Card)`
  background-color: ${({ theme }) => theme.card.bg.primary};
  border: 1px solid ${({ theme }) => theme.card.border.quaternary};
  border-radius: 10px;

  .card-title,
  .card-text {
    text-align: center;
    color: ${({ theme }) => theme.card.font.primary};
  }

  .card-text {
    font-size: 14px;
    font-weight: 500;
  }

  .card-body {
    color: ${({ theme }) => theme.card.color.tertiary};
  }
`;
